export default __webpack_public_path__ + "static/media/delivered.9b744f26.svg";